import { BasePayloadMapper } from '@ps/utils';
import type {
  SupplierBlendFlexibilityMode,
  SupplierBlendSave,
} from '@ps/survey-utils';

import {
  SupplierBlendFlexibilitySelectedTypeDto,
  SupplierBlendPayloadDto,
  SupplierBlendPayloadSupplierDto,
} from '../dtos/supplier-blend.dto';

const FLEXIBILITY_SELECTED_TYPE: Record<
  SupplierBlendFlexibilityMode,
  SupplierBlendFlexibilitySelectedTypeDto
> = {
  global: { key: 0, value: 'Global' },
  selective: { key: 1, value: 'Selective' },
  none: { key: 2, value: 'None' },
};

export class SupplierBlendPayloadMapper extends BasePayloadMapper<
  SupplierBlendSave,
  SupplierBlendPayloadDto
> {
  public toPayload(model: SupplierBlendSave): SupplierBlendPayloadDto {
    return {
      config_name: model.name,
      is_default: model.isDefault,
      is_locked: model.isLocked,
      locale: model.locale,
      blend_flexibility: model.globalFlexibilityPercentage ?? 0,
      flexibilitySelectedType: FLEXIBILITY_SELECTED_TYPE[model.flexibilityMode],
      suppliers: model.groups.map(
        (group): SupplierBlendPayloadSupplierDto => ({
          group_name: group.groupName,
          id: group.groupName === '' ? String(group.members[0]?.id ?? '') : '',
          supplier_id: group.members.map((member) => ({
            id: member.id,
            allocation:
              member.allocation ?? group.allocationPercentage ?? undefined,
          })),
          allocation_percentage: Number.isFinite(group.allocationPercentage)
            ? String(group.allocationPercentage)
            : undefined,
          flexibility_percentage:
            model.flexibilityMode === 'selective' &&
            Number.isFinite(group.flexibilityPercentage)
              ? String(group.flexibilityPercentage)
              : undefined,
          is_custom_allocation: group.isCustomAllocation,
        }),
      ),
    };
  }
}
